
export class ControllerEventName {

  static readonly ActivatedRoute = 'ActivatedRoute';
  static readonly ScreenConfigLoaded = 'ScreenConfigLoaded';
  static readonly PersistScreenConfig = 'PersistScreenConfig';
  static readonly ClearEntityFilters = 'ClearEntityFilters';
  static readonly EntityFiltersUpdated = 'EntityFiltersUpdated';
  static readonly EntitySortsUpdated = 'EntitySortsUpdated';
  static readonly EntityDeleted = 'EntityDeleted';
  static readonly UpdateColumnSpecs = 'UpdateColumnSpecs';
  static readonly ColumnSpecsUpdated = 'ColumnSpecsUpdated';
  static readonly CancelForm = 'CancelForm';
  static readonly SubmitForm = 'SubmitForm';
  static readonly RawFileLoaded = 'RawFileLoaded';
  static readonly FileObjectLoaded = 'FileObjectLoaded';
  static readonly FileObjectRemoved = 'FileObjectRemoved';
  static readonly UpdateTitle = 'UpdateTitle';
  static readonly UpdateSubTitle = 'UpdateSubTitle';
  static readonly ImpersonateUser = 'ImpersonateUser';
  static readonly AddActionBarItem = 'AddActionBarItem';
  static readonly RemoveActionBarItem = 'RemoveActionBarItem';
  static readonly ActionBarItemEvent = 'ActionBarItemEvent';
  static readonly ExportTable = 'ExportTable';
  static readonly EntityListReloadRequest = 'EntityListReloadRequest';
}
